/*
  Same as withRouter() HOC but with a hook
  Used like:
  const { history } = useRouterContext()
*/
import { useContext } from 'react';
import { __RouterContext } from 'react-router-dom';

function useRouterContext() {
  const routerContext = useContext(__RouterContext);
  return routerContext;
}

export default useRouterContext;
